import HealthyHeartslogo from '../assets/HealthyHeartslogo.png';
import TheCHECLogo from '../assets/TheCHECLogo.png';

export default {
    HealthyHeartslogo,
    TheCHECLogo
};